module.exports = __webpack_public_path__ + "img/Vector.139f5250.svg";